import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Tooltip from "../Tooltip";
import Bubble from "../Bubble";
import SaleRow from "../SaleRow";
import Icon from "../Icon";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var ProductParameters = function ProductParameters(props) {
  return /*#__PURE__*/React.createElement("table", {
    className: cx('table', props.className),
    "data-t-id": "components-ProductParameters"
  }, /*#__PURE__*/React.createElement("tbody", null, props.children));
};
ProductParameters.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  className: PropTypes.string
} : {};
export var ProductParameter = /*#__PURE__*/function (_Component) {
  _inherits(ProductParameter, _Component);
  var _super = _createSuper(ProductParameter);
  function ProductParameter() {
    _classCallCheck(this, ProductParameter);
    return _super.apply(this, arguments);
  }
  _createClass(ProductParameter, [{
    key: "renderLegal",
    value: function renderLegal() {
      var legal = this.props.legal;
      if (!legal) return null;
      var tooltip = /*#__PURE__*/React.createElement(Tooltip, {
        icon: legal.type === 'present' ? 'present' : '',
        type: typeof legal === 'string' ? 'common' : legal.type
      }, /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: typeof legal === 'string' ? legal : legal.text
        },
        "data-t-id": "components-ProductParameters"
      }));
      return /*#__PURE__*/React.createElement("div", {
        className: cx('tooltip-wrapper')
      }, /*#__PURE__*/React.createElement("div", {
        className: cx('tooltip')
      }, tooltip));
    }
  }, {
    key: "renderRow",
    value: function renderRow() {
      var _this$props = this.props,
        type = _this$props.type,
        label = _this$props.label,
        value = _this$props.value,
        unit = _this$props.unit,
        tip = _this$props.tip,
        className = _this$props.className,
        icon = _this$props.icon,
        fullPrice = _this$props.fullPrice,
        discountValue = _this$props.discountValue,
        subscriptionFeeDiscount = _this$props.subscriptionFeeDiscount;
      var discount = type === 'discounted-sim';
      return value ? /*#__PURE__*/React.createElement("tr", {
        className: cx('row', className, {
          discount: discount
        })
      }, /*#__PURE__*/React.createElement("td", {
        className: cx('label')
      }, discount && icon && /*#__PURE__*/React.createElement("div", {
        className: cx('discountIcon')
      }, /*#__PURE__*/React.createElement("img", {
        alt: "",
        className: cx('icon'),
        src: icon
      })), /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: label
        }
      }), tip && /*#__PURE__*/React.createElement("div", {
        className: cx('tip'),
        dangerouslySetInnerHTML: {
          __html: tip
        }
      })), subscriptionFeeDiscount ? /*#__PURE__*/React.createElement("div", {
        className: cx('wrap--subscription')
      }, /*#__PURE__*/React.createElement("span", {
        className: cx('price'),
        dangerouslySetInnerHTML: {
          __html: "".concat(value, " ").concat(unit)
        }
      }), ' ', /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: subscriptionFeeDiscount
        }
      })) : /*#__PURE__*/React.createElement("td", {
        className: cx('value')
      }, /*#__PURE__*/React.createElement("span", {
        className: cx('valueNumber', {
          withUnit: unit
        }),
        dangerouslySetInnerHTML: {
          __html: value
        }
      }), ' ', /*#__PURE__*/React.createElement("span", {
        className: cx('valueUnit'),
        dangerouslySetInnerHTML: {
          __html: unit
        }
      }), this.renderLegal(), discount && fullPrice && discountValue ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: cx('price'),
        dangerouslySetInnerHTML: {
          __html: "".concat(fullPrice, " &#8381;")
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: cx('saleLabel')
      }, "-", discountValue, "%")) : null)) : /*#__PURE__*/React.createElement("tr", {
        className: cx('row', 'noValue', className)
      }, /*#__PURE__*/React.createElement("td", {
        className: cx('label'),
        colSpan: 2
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: label
        }
      }), this.renderLegal()));
    }
  }, {
    key: "renderRawData",
    value: function renderRawData() {
      var _this$props2 = this.props,
        label = _this$props2.label,
        value = _this$props2.value,
        className = _this$props2.className;
      return /*#__PURE__*/React.createElement("tr", {
        className: cx('row', className)
      }, /*#__PURE__*/React.createElement("td", {
        className: cx('label', {
          wideLabel: !value
        }),
        colSpan: !value ? 2 : false
      }, label), value ? /*#__PURE__*/React.createElement("td", {
        className: cx('value')
      }, value) : null);
    }
  }, {
    key: "renderCrossing",
    value: function renderCrossing() {
      return /*#__PURE__*/React.createElement("tr", {
        className: cx('crossingRow')
      }, /*#__PURE__*/React.createElement("td", {
        className: cx('cell')
      }), /*#__PURE__*/React.createElement("td", {
        className: cx('cell')
      }, /*#__PURE__*/React.createElement("span", {
        className: cx('strikedOutValue'),
        dangerouslySetInnerHTML: {
          __html: "".concat(this.props.value, " ").concat(this.props.unit || '')
        }
      })));
    }
  }, {
    key: "renderBubble",
    value: function renderBubble() {
      return /*#__PURE__*/React.createElement("tr", {
        className: cx('bubbleRow')
      }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Bubble, {
        className: ['topRight', cx('bubble')]
      }, /*#__PURE__*/React.createElement(Icon, {
        className: cx('icon'),
        name: "present",
        "data-t-id": "components-ProductParameters"
      }), /*#__PURE__*/React.createElement("div", {
        className: cx('text'),
        dangerouslySetInnerHTML: {
          __html: this.props.label
        }
      }))), /*#__PURE__*/React.createElement("td", null));
    }
  }, {
    key: "renderAction",
    value: function renderAction() {
      return /*#__PURE__*/React.createElement("tr", {
        className: cx('actionRow')
      }, /*#__PURE__*/React.createElement("td", {
        className: cx('cell'),
        colSpan: "2"
      }, /*#__PURE__*/React.createElement(SaleRow, {
        className: "inherit"
      }, /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: this.props.label
        },
        "data-t-id": "components-ProductParameters"
      }))));
    }
  }, {
    key: "renderButton",
    value: function renderButton() {
      var _this$props3 = this.props,
        value = _this$props3.value,
        className = _this$props3.className;
      return /*#__PURE__*/React.createElement("tr", {
        className: cx('row', 'buttonRow', className)
      }, /*#__PURE__*/React.createElement("td", {
        className: cx('label')
      }), /*#__PURE__*/React.createElement("td", {
        className: cx('value')
      }, value));
    }
  }, {
    key: "render",
    value: function render() {
      var type = this.props.type;
      switch (type) {
        case 'crossing':
          return this.renderCrossing();
        case 'bubble':
          return this.renderBubble();
        case 'action':
          return this.renderAction();
        case 'button':
          return this.renderButton();
        case 'rawData':
          return this.renderRawData();
        case 'discounted-sim':
        case 'normal':
        default:
          return this.renderRow();
      }
    }
  }]);
  return ProductParameter;
}(Component);
ProductParameter.defaultProps = {
  value: '',
  type: 'normal',
  icon: 'http://static.beeline.ru/upload/images/b2c/icons/percentage.svg',
  fullPrice: ''
};
ProductParameter.propTypes = process.env.NODE_ENV !== "production" ? {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  legal: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  type: PropTypes.string,
  tip: PropTypes.string,
  icon: PropTypes.string,
  fullPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string
} : {};